import React, { useState, forwardRef, useImperativeHandle } from 'react';
import SavedReportsPanel from './SavedReportsPanel';
import ReferencedFilesPanel from './ReferencedFilesPanel';
import './LeftPanel.css';

const LeftPanel = forwardRef(({
  savedReportsPanelRef,
  savedReports,
  setSavedReports,
  onLoadReport,
  user,
  selectedWorkspace,
  onSaveReport,
  onSelectedFilesChange,
  onOpenReportEditor,
  reportProgressEvents,
}, ref) => {
  const [selectedReferenceFiles, setSelectedReferenceFiles] = useState([]);

  // Expose selected files to parent component
  useImperativeHandle(ref, () => ({
    getSelectedFiles: () => selectedReferenceFiles
  }));

  const handleFileSelect = (file) => {
    setSelectedReferenceFiles(prev => {
      // Check if file already selected
      if (prev.some(f => f.file_id === file.file_id)) {
        return prev;
      }
      const updated = [...prev, file];
      if (onSelectedFilesChange) {
        onSelectedFilesChange(updated);
      }
      return updated;
    });
  };

  const handleFileDeselect = (fileId) => {
    setSelectedReferenceFiles(prev => {
      const updated = prev.filter(f => f.file_id !== fileId);
      if (onSelectedFilesChange) {
        onSelectedFilesChange(updated);
      }
      return updated;
    });
  };

  // Clear selected files when workspace changes
  React.useEffect(() => {
    setSelectedReferenceFiles([]);
    if (onSelectedFilesChange) {
      onSelectedFilesChange([]);
    }
  }, [selectedWorkspace?.workspace_id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="left-panel-container">
      <div className="left-panel-section saved-reports-section-container">
        <SavedReportsPanel
          ref={savedReportsPanelRef}
          savedReports={savedReports}
          setSavedReports={setSavedReports}
          onLoadReport={onLoadReport}
          user={user}
          selectedWorkspace={selectedWorkspace}
          onSaveReport={onSaveReport}
          onOpenReportEditor={onOpenReportEditor}
          reportProgressEvents={reportProgressEvents}
        />
      </div>
      <div className="left-panel-section referenced-files-section-container">
        <ReferencedFilesPanel
          selectedWorkspace={selectedWorkspace}
          selectedFiles={selectedReferenceFiles}
          onFileSelect={handleFileSelect}
          onFileDeselect={handleFileDeselect}
        />
      </div>
    </div>
  );
});

LeftPanel.displayName = 'LeftPanel';

export default LeftPanel;

